import { DEFAULT_THEME_COLORS } from '@/domain/models/theme.js';
import type { ThemeColors, ThemeConfig } from '@/infra/theme/theme-config.js';
import { APP_FONT_FAMILY, APP_FONT_URL } from '@/shared/constants/typography.js';

export const LIGHT_THEME_COLORS: ThemeColors = { ...DEFAULT_THEME_COLORS };

export const DARK_THEME_COLORS: ThemeColors = {
    primary: '#F7941F',
    primaryLight: '#FDB848',
    primaryDark: '#D97A00',
    secondary: '#FF4747',
    secondaryLight: '#FF7676',
    secondaryDark: '#E02020',
    background: '#0E0E18',
    surface: '#18182A',
    border: '#2C2C42',
    error: '#f2555a',
    warning: '#f5a623',
    success: '#3dd68c',
    info: '#3dadff',
    textPrimary: '#EDEEF2',
    textSecondary: '#9B9DAB'
};

export const DEFAULT_THEME: ThemeConfig = {
    colors: { ...LIGHT_THEME_COLORS },
    logos: { header: '', secondary: '', login: '', favicon: '' },
    typography: {
        fontFamily: APP_FONT_FAMILY,
        headingFontFamily: APP_FONT_FAMILY,
        fontUrl: APP_FONT_URL,
        baseFontSize: '14px'
    },
    layout: { borderRadius: '8px', headerHeight: '56px', sidebarWidth: '240px' },
    darkMode: 'light',
    customCss: ''
};
